import { render, staticRenderFns } from "./ParceriaQuitandinha.vue?vue&type=template&id=dcf99fd8&"
import script from "./ParceriaQuitandinha.vue?vue&type=script&lang=js&"
export * from "./ParceriaQuitandinha.vue?vue&type=script&lang=js&"
import style0 from "./ParceriaQuitandinha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports